import Swiper from 'swiper';
import { A11y, Pagination } from 'swiper/modules';
Swiper.use([ A11y, Pagination]);

jQuery(document).ready(function() {
  if (jQuery('.swiper-facilities').length) {
    new Swiper('.swiper-facilities', {
      spaceBetween: 15,
      speed: 1000,
      enabled: true,
      slidesPerView: 1,
      a11y: {
        enabled: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletElement: 'button',
      },
      breakpoints: {
        991: {
          slidesPerView: 'auto',
          enabled: false,
          spaceBetween: 0,
        },
        767: {
          slidesPerView: 4,
          enabled: true,
          spaceBetween: 15,
        },
        575: {
          slidesPerView: 3,
          enabled: true,
          spaceBetween: 15,
        },
        400: {
          slidesPerView: 2,
          enabled: true,
          spaceBetween: 15,
        },
      },
    });
  }
});
